/** Dev (localhost) specific tenant settings */

module.exports = {
  apiBase: 'http://api.sparkpost.test/api',
  authentication: {
    app: {
      cookie: {
        options: {
          secure: false
        }
      }
    },
    site: {
      cookie: {
        options: {
          domain: '.sparkpost.test',
          secure: false
        }
      }
    }
  },
  cookieConsent: {
    cookie: {
      options: {
        domain: 'sparkpost.test'
      }
    }
  },
  crossLinkTenant: 'spc', // so we can test locally
  featureFlags: {
    allow_default_signing_domains_for_ip_pools: true,
    allow_mailbox_verification: true,
    allow_anyone_at_verification: true,
    has_signup: true
  },
  gaTag: 'UA-111136819-2',
  gtmId: 'GTM-P87NNJ4',
  segment: {
    enabled: false,
    publicKey: 'LR3TCDRu7vPZfty8FPZsg4Oe1WTmpAtt'
  },
  sentry: {
    projectId: 232588,
    publicKey: '63149b1565df4b7199db939a4410b47a',
    dsn: 'https://63149b1565df4b7199db939a4410b47a@o104929.ingest.sentry.io/232588'
  },
  rudderstack: {
    enabled: true,
    publicKey: '2A59r5cgf9ZJnZBtj6kggLgmQKM'
  },
  siftScience: {
    id: '88affa8e11'
  },
  splashPage: '/dashboard',
  smtpAuth: {
    host: 'smtp.sparkmail.com',
    alternativePort: 2525
  },
  website: {
    domain: 'sparkpost.test'
  }
};
